import Vue from 'vue'
import Router from 'vue-router'

import Auth from '@/views/auth-view.vue'
import Home from '@/views/home-view.vue'
import Basket from '@/views/basket-view.vue'
import Confirmation from '@/views/payment-conf.vue'
import Customer from '@/views/customer-view.vue'
import Eshop from '@/views/eshop-view.vue'
import Login from '@/views/login-view.vue'
import Logout from '@/views/logout-view.vue'
import Payment from '@/views/payment-view.vue'
import Reservations from '@/views/reservations-view.vue'

Vue.use(Router)

// index router
const router = new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'base',
      redirect: { name: 'home' }
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/logout',
      name: 'logout',
      component: Logout
    },
    {
      path: '/auth',
      name: 'auth',
      component: Auth
    },
    {
      path: '/home',
      name: 'home',
      component: Home,
      meta: { checkToken: true, canLogin: true }
    },
    {
      path: '/customer',
      name: 'customer',
      component: Customer,
      meta: { checkToken: true, checkRegistered: true, canLogin: true }
    },
    {
      path: '/reservations',
      name: 'reservations',
      component: Reservations,
      meta: { checkToken: true, checkRegistered: true, canLogin: true }
    },
    {
      path: '/eshop',
      name: 'eshop',
      component: Eshop,
      meta: { checkToken: true, canLogin: true }
    },
    {
      path: '/basket',
      name: 'basket',
      component: Basket,
      meta: { checkToken: true, checkBasket: true, canLogin: true }
    },
    {
      path: '/payment',
      name: 'payment',
      component: Payment,
      children: [{
        path: 'confirmation',
        name: 'confirmation',
        component: Confirmation,
        props: (route) => ({ query: route.query })
      }],
      meta: { checkToken: true, checkBasket: true, checkPayment: true, canLogin: true }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.checkToken) && Vue.prototype !== undefined && !Vue.prototype.$oauth2.hasAccessToken()) {
    console.log(Vue.prototype)
    console.log(Vue.prototype.$oauth2.hasAccessToken())
    next({ name: 'login' })
  } else if (to.matched.some(record => record.meta.checkRegistered) && (Vue.prototype === undefined || Vue.prototype.$oauth2.isGuest())) {
    next({ name: 'home' })
  } else if (to.matched.some(record => record.meta.checkBasket) && (!Vue.prototype.$basket.basket.items || Vue.prototype.$basket.basket.items.length === 0)) {
    next({ name: from.name })
  } else if (to.matched.some(record => record.meta.checkPayment) && (!Vue.prototype.$basket.basket.items || Vue.prototype.$basket.basket.items.length === 0 || Vue.prototype.$basket.basket.necessaryCreditToCharge > 0)) {
    next({ name: from.name })
  } else {
    next()
  }
})

export default router
